import { makeStyles } from '@material-ui/core';

const FONT_FAMILIES = {
  bold: 'MontserratBold',
  regular: 'Montserrat'
};

const COLORS = {
  primary: '#06E89F',
  white: '#FFF'
};

const FONT_WEIGHTS = {
  bold: 700,
  medium: 500
};

const useStyles = makeStyles((theme) => ({
  containerSlide: (props) => ({
    background: `
      url(${props.backgroundImg}) 
      center center / 100% 100% 
      no-repeat 
      scroll
    `,
    width: '100%',
    height: '691px',
    borderTopWidth: '123px',
    marginTop: '64px',
    [theme.breakpoints.down('xs')]: {
      height: 'auto',
    },
  }),

  contentSlide: {
    height: '100%',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    width: '100%',
    [theme.breakpoints.down('xs')]: {
      padding: '25px 0',
    },
  },

  comingSoon: {
    display: 'flex',
    fontFamily: FONT_FAMILIES.bold,
    fontSize: '60px',
    fontWeight: FONT_WEIGHTS.bold,
    color: COLORS.primary,
    textAlign: 'left',
    lineHeight: '54.36px',
    [theme.breakpoints.down('md')]: {
      fontSize: '60px',
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '41px',
      lineHeight: '42.36px',
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: '40px',
      lineHeight: '42.36px',
    },
  },

  text: {
    display: 'flex',
    fontFamily: FONT_FAMILIES.regular,
    fontWeight: FONT_WEIGHTS.medium,
    color: COLORS.white,
    fontSize: '40px',
    lineHeight: '48px',
    textAlign: 'left',
    [theme.breakpoints.down('sm')]: {
      fontSize: '40px',
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: '38px',
      lineHeight: '42px',
    },
  },

  buttonSlide: {
    display: 'flex',
    justifyContent: 'flex-start',
    marginTop: '70px',
    [theme.breakpoints.down('md')]: {
      marginTop: '60px',
    },
    [theme.breakpoints.down('xs')]: {
      marginTop: '40px',
    },
  },
}));

export default useStyles;
